import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { AssociatedCompany } from '../../types';

interface Props {
  company: AssociatedCompany;
  onDeleteClick: (company: AssociatedCompany) => void;
}

export const AssociatedCompanyMenuItems = ({
  company,
  onDeleteClick,
}: Props) => {
  const { t } = useTranslation();
  return (
    <MenuItem disabled={false} onClick={() => onDeleteClick(company)}>
      <ListItemIcon>
        <DeleteIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{t('users.actions.delete')}</ListItemText>
    </MenuItem>
  );
};
